/**
 * <kurzus-ragados-sav> — mobil vásárlósáv a képernyő alján.
 *
 * MIKOR LÁTSZIK
 * Megjelenik, amikor a látogató elhagyta az első képernyőt, és eltűnik,
 * amikor az árdoboz látszik — ott már ott van a valódi gomb, két egymás
 * alatti felhívás pedig zavaró.
 *
 * MIÉRT IntersectionObserver, ÉS NEM scroll-esemény
 * A scroll-listener minden képkockánál fut a fő szálon, és mobilon érezhetően
 * akadozóvá teszi a görgetést. Az observer a böngésző saját ütemezésében fut.
 *
 * MIÉRT WEB COMPONENT
 * A Theme Editor futás közben újrarendereli a szekciókat; egy egyszeri
 * inicializálás az újrarenderelt példányra már nem futna le. A
 * disconnectedCallback leszereli az observert, hogy ne maradjon szivárgás.
 */

class KurzusRagadosSav extends HTMLElement {
  connectedCallback() {
    // A CSS `prefers-reduced-motion` esetén sem tiltja a sávot, csak az
    // átúszást — a vásárlási útvonal nem díszítés.
    this.figyeltAzonosito = this.dataset.figyelt || 'ajanlat';

    this.orszemLetrehoz();
    this.figyelesInditas();

    this.hidden = false;
  }

  disconnectedCallback() {
    this.megfigyelo?.disconnect();
    this.orszem?.remove();
  }

  /**
   * Egy nulla magasságú jelölő a dokumentum elején. Amíg ez látszik, a
   * látogató az első képernyőn van. Így nem kell tudnunk, melyik szekció
   * a hero — bármilyen sorrendben működik.
   */
  orszemLetrehoz() {
    this.orszem = document.createElement('div');
    this.orszem.setAttribute('aria-hidden', 'true');
    this.orszem.style.cssText = 'position:absolute;top:70vh;left:0;width:1px;height:1px;pointer-events:none;';
    document.body.prepend(this.orszem);
  }

  figyelesInditas() {
    const arDoboz = document.getElementById(this.figyeltAzonosito);
    const figyeltek = [this.orszem];
    if (arDoboz) figyeltek.push(arDoboz);

    this.elsoKepernyon = true;
    this.arDobozLatszik = false;

    this.megfigyelo = new IntersectionObserver(
      (bejegyzesek) => {
        for (const b of bejegyzesek) {
          if (b.target === this.orszem) {
            this.elsoKepernyon = b.isIntersecting;
          } else {
            this.arDobozLatszik = b.isIntersecting;
          }
        }
        this.frissit();
      },
      { rootMargin: '0px 0px -20% 0px' }
    );

    for (const elem of figyeltek) this.megfigyelo.observe(elem);
  }

  frissit() {
    const mutassuk = !this.elsoKepernyon && !this.arDobozLatszik;

    if (mutassuk) {
      this.setAttribute('data-latszik', '');
    } else {
      this.removeAttribute('data-latszik');
    }
  }
}

if (!customElements.get('kurzus-ragados-sav')) {
  customElements.define('kurzus-ragados-sav', KurzusRagadosSav);
}
